export default {
  // 图面统一前缀
  retun_img(e) {
    if (e != undefined) {
      if (e.split('.')[e.split('.').length - 1] == 'bfm2' || e.split('.')[e.split('.').length - 1] == 'bfm' || e.split('.')[
        e.split('.').length - 1] == 'mp4' || e.split('.')[e.split('.').length - 1] == 'zip') {
        return '暂无预览';
      }
      return `https://sourcelib.oss-cn-qingdao.aliyuncs.com/${e}`;
    }
  },
  // oss的前缀
  retun_ossimg(e) {
    return `https://sourcelib.oss-cn-qingdao.aliyuncs.com/upload/${e}`;
  },
  // oss的前缀
  retun_touxiangimg(e) {
    if (e != undefined) {
      return `https://sourcelib.oss-cn-qingdao.aliyuncs.com/${e}`;
    }
    return '/img/headpath.e2c620ca.png';
  },
  // 获取当前url的参数
  GetRequest(url) {
    if (typeof (url) === 'undefined') url = location.href;
    const theRequest = new Object();
    if (url.indexOf('?') != -1) {
      const str = url.substr((url.indexOf('?') + 1));
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
      }
    }
    return theRequest;
  },
};
